
<ion-header class="ion-no-border">
  <app-vendor-header></app-vendor-header>
</ion-header>
<ion-content class="bg-color padding dashboard">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <a>
            {{ itemList.label }}
          </a>
        </li>
      </ul>
    </div>
    <div class="content-grid">
      <div class="dashboard-pv">
        <div class="dashboard-profile-pic">
          <div class="profile-pic">
            <img [src]="profileImagePath">
          </div>
          <!-- <img src="assets/images/Profil.svg" style="display:inline-block;margin:2px 0 2px 2px;border-radius: 50%;" width="120"> -->
          <span class="profile-name">{{profileName}}</span>
        </div>
        <div class="dashboard-quick-view">
          <div style="cursor: pointer" class="profile-view-sec" id="dashboard_profile" [routerLink]="['/vendor/baseapp/profile']">
            <div class="profile-view-sec-img">
              <img src="assets/images/profile-avatar.svg">
            </div>
            <div class="profile-view-sec-text">Profile</div>
          </div>
          <div style="cursor: pointer" class="profile-view-sec" id="dashboard_ib_list">
            <div class="profile-view-sec-img">
              <img src="assets/images/eZintegrations.svg">
            </div>
            <div class="profile-view-sec-text">eZintegrations</div>
          </div>
          <div style="cursor: pointer" class="profile-view-sec" id="dashboard_support">
            <div class="profile-view-sec-img">
              <img src="assets/images/support.svg">
            </div>
            <div class="profile-view-sec-text">Support</div>
          </div>
          <div class="profile-view-sec" id="dashboard_monitor">
            <div class="profile-view-sec-img">
              <img src="assets/images/Monitor.svg">
            </div>
            <div class="profile-view-sec-text">Monitor</div>
          </div>
          <div style="cursor: pointer" class="profile-view-sec" id="dashboard_market">
            <div class="profile-view-sec-img">
              <img src="assets/images/Marketplace.svg">
            </div>
            <div class="profile-view-sec-text">Marketplace</div>
          </div>
          <div style="cursor: pointer" id="dashboard_api_catelog" class="profile-view-sec">
            <div class="profile-view-sec-img">
              <img src="assets/images/API catalog.svg">
            </div>
            <div class="profile-view-sec-text">API Catalog</div>
          </div>
        </div>
      </div>

      <div class="cgrid recent-views">
        <mat-card>
          <mat-card-title>Recent Views</mat-card-title>
          <!-- <mat-divider class="mat-divider"></mat-divider> -->


          <!-- <perfect-scrollbar class="scroll-container" fxFlex="auto" [config]="config" [scrollIndicators]="true"> -->
          <mat-card-content class="views-content-inner">
            <div class="views">
              <cdk-virtual-scroll-viewport itemSize="10" class="example-viewport">
                <!-- <div class="views-pic">
                              <img src="assets/images/profile-avatar.svg" />
                          </div> -->
                <div class="views-content" *cdkVirtualFor="let recentView of recentViews">
                  <span>You Opened <a href="{{recentView.visited_page_url}}">{{recentView.action}}</a> at
                    {{recentView.visited_date | date: 'medium'}}</span>
                </div>
              </cdk-virtual-scroll-viewport>
            </div>
          </mat-card-content>
          <!-- </perfect-scrollbar> -->


        </mat-card>
      </div>
      <div class="cgrid update-views">
        <!-- <cdk-virtual-scroll-viewport itemSize="50" class="example-viewport">
            <div class="views" style="display:block;"  *cdkVirtualFor="let updateView of UpdateViews">
              <span>{{updateView.event_name}}</span><br>
              <p class="eventDesc text-ellipsis">{{updateView.description}}</p>
            </div>
          </cdk-virtual-scroll-viewport> -->
        <mat-card>
          <mat-card-title>Product Updates</mat-card-title>
          <mat-card-content class="views-content-inner">
            <div class="views">
              <cdk-virtual-scroll-viewport itemSize="10" class="example-viewport">
                <div class="update-views-content example-item" style="display:block;"
                  *cdkVirtualFor="let updateView of UpdateViews">
                  <span style="font-weight: bold;">{{updateView.event_name}}</span><br>
                  <p style="color: #4e4e4e;" class="eventDesc text-ellipsis" [innerHTML]="updateView.description"></p>
                </div>
              </cdk-virtual-scroll-viewport>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>

<!-- <ion-footer>
    <ion-toolbar>
        <div class="footer-logo">
            <img src="assets/images/eZintegration-black-logo.svg">
        </div>
    </ion-toolbar>
</ion-footer> -->